
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotissue/all",
      function () {
        return require("private-next-pages/hotissue/all/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotissue/all"])
      });
    }
  